import { render, staticRenderFns } from "./TpvModal.vue?vue&type=template&id=1f26a84d&scoped=true"
import script from "./TpvModal.vue?vue&type=script&lang=js"
export * from "./TpvModal.vue?vue&type=script&lang=js"
import style0 from "./TpvModal.vue?vue&type=style&index=0&id=1f26a84d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f26a84d",
  null
  
)

export default component.exports